<template>
  <div class="clinic-qr-landing">
    <div>
      <img class="logo" :src="nowServingLogo" alt="NowServing">
    </div>
    <div class="mb-m">
      <smd-loading-spinner/>
    </div>
    <p>Connecting you to the clinic...</p>
  </div>
</template>

<script>
  import {mapActions} from 'vuex';
  import nsLogo from '@/assets/images/now-serving-logo-horizontal.svg';
  import {getAccessToken} from '@/utils/access-token';
  import {isEmpty} from '@/utils';
  import {
    ACTION_SET_CLINIC_QR_DOCTOR_TOKEN,
  } from '@/store/types';
  import {
    HOME_ROUTE,
    LOGIN_ROUTE,
    CLINIC_QR_DOCTOR_PARAM,
  } from '@/router/routes';

  export default {
    name: 'clinic-qr-landing',
    props: {
      [CLINIC_QR_DOCTOR_PARAM]: {type: String, default: null},
    },
    data() {
      return {
        nowServingLogo: nsLogo,
      };
    },
    mounted() {
      const token = this[CLINIC_QR_DOCTOR_PARAM];

      if (token) {
        this.setClinicQrDoctorToken(token);
      }

      this.handleRedirect();
    },
    methods: {
      ...mapActions({
        setClinicQrDoctorToken: ACTION_SET_CLINIC_QR_DOCTOR_TOKEN,
      }),
      handleRedirect() {
        if (isEmpty(getAccessToken())) {
          this.$router.push({name: LOGIN_ROUTE});
        } else {
          this.$router.push({name: HOME_ROUTE});
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .clinic-qr-landing {
    display: flex;
    flex-direction: column;
    position: fixed;
    justify-content: center;
    align-items: center;
    inset: 0;
    width: 100%;
    height: 100%;
    margin: auto;
    background-color: white;
    z-index: 2;
  }

  .logo {
    @include space-me($prop: margin, $all: l);
    padding: space(m);
    width: 350px;
    height: 120px;
  }
</style>
